import { render } from "./ServiceFormPage.vue?vue&type=template&id=7cab3b24&ts=true"
import script from "./ServiceFormPage.vue?vue&type=script&lang=ts"
export * from "./ServiceFormPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__